import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/GetHistogramConstant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var moment = require('moment');
var organization, country, locality, area, profileId;
var dateRange = {}, filters = {};

var GetLocationInsightAction = function () {

}

GetLocationInsightAction.prototype = {

	addFilters: function (data) {
		filters = data;
		this.loadData();
	},

	clearFilters: function () {
		filters = {};
	},

	changeProfile: function (value) {
		profileId = value;
		this.loadData();
	},

	changeOrganisation: function (value) {
		organization = value;
		this.loadData();
	},

	addDownloadFilters: function (data) {
		if (data.profileId) {
			profileId = data.profileId;
			delete data.profileId
		}
		if (data.hasOwnProperty('insightFilters')) {
			delete data.insightFilters;
			// console.log("reqdata1", data)
		}
		// if(data.granularity){
		// 	granularity = data.granularity;
		// 	// delete data.granularity;
		// }
		// console.log("reqdata", data)
		filters = data;
		this.loadData();
	},

	addDates: function (fromDate, toDate) {
		dateRange.from = fromDate;
		dateRange.to = toDate;
		this.loadData();
	},

	addCountry: function (value) {
		country = value;
		locality = undefined;
		area = undefined;
		this.loadData()
	},

	addArea: function (value) {
		area = value;
		locality = undefined;
		this.loadData();
	},

	addLocality: function (value) {
		locality = value;
		this.loadData();
	},

	loadData: function () {

		// if(filters.hasOwnProperty('reviewFilters')){
		// 	if(!(filters.reviewFilters.hasOwnProperty('dateRange'))){
		// 		filters['reviewFilters']['dateRange'] = {}
		// 		var dateRange = {};
		// 		dateRange.from = moment().subtract(8, 'week').format('YYYY-MM-DD');
		// 		dateRange.to = moment().format('YYYY-MM-DD');
		// 		filters['reviewFilters']['dateRange'] = dateRange;
		// 	}

		// }else{
		// 	filters['reviewFilters'] = {};
		// 	filters['reviewFilters']['dateRange'] = {}
		// 	var dateRange = {};
		// 	dateRange.from = moment().subtract(8, 'week').format('YYYY-MM-DD');
		// 	dateRange.to = moment().format('YYYY-MM-DD');
		// 	filters['reviewFilters']['dateRange'] = dateRange;
		// }

		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		var data = {
			profileId: localStorage.getItem('profileId'),
			filters: filters
		}
		if (data.filters.hasOwnProperty('insightFilters')) {
			delete data.filters.insightFilters;
		}

		restClient.getLocationInsight(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.LOCATION_INSIGHTS,
					data: response
				});
			}
		})
	}
}

export default new GetLocationInsightAction();